import React, { useState } from "react"
import { getCookieConsentValue } from "react-cookie-consent"

// component
import Cookie from "../cookie/cookie.component"

// svg
import Icon from "../../assets/cookie.svg"

// styles
import { Container } from "./cookie-banner.styles"

const CookieBanner = () => {
  const [visible, setVisibility] = useState(
    typeof window !== "undefined" &&
      getCookieConsentValue("gaRecaptcha") !== undefined
  )

  return visible ? (
    <Container
      active={visible}
      onClick={() => {
        setVisibility(false)
      }}
    >
      <Icon />
    </Container>
  ) : (
    <Cookie onClick={setVisibility} visible={visible} />
  )
}

export default CookieBanner
